import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { serviceImages } from '../data/images';
import type { ServiceId } from '../types/copy';
import { ServiceCard } from './ServiceCard';
interface ServicesProps {
  onOpen: (id: ServiceId) => void;
}
export function Services({
  onOpen
}: ServicesProps) {
  const {
    t
  } = useLanguage();
  const s = t.services;
  return <section id="services" aria-labelledby="services-title" className="scroll-mt-20 bg-violet-soft py-24 md:py-32" data-id="element-345" data-mp="13vl84dgr0z1h">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-346" data-mp="z4cyphff5dob">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-347" data-mp="u5s4bymulo7s">
          <h2 id="services-title" className="font-display text-[30px] font-medium tracking-[-0.01em] text-ink md:text-[36px]" data-id="element-348" data-mp="q4gafgwxygts">
            {s.title}
          </h2>
          <p className="max-w-md text-[17px] text-muted md:text-right" data-id="element-349" data-mp="g6afxkdgscyy">{s.intro}</p>
        </div>

        <ul className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-350" data-mp="36chkm9obbm07">
          {s.items.map(item => <li key={item.id} data-id="element-351" data-mp="3b2xzly7s7foo">
              <ServiceCard service={item} image={serviceImages[item.id]} learnMore={s.learnMore} onOpen={() => onOpen(item.id)} data-id="element-352" data-mp="3b3zl6wmfbkkn" />
            </li>)}
        </ul>

        <div className="mt-16 grid gap-6 border-t border-violet/20 pt-10 lg:grid-cols-12 lg:gap-20" data-id="element-353" data-mp="3q0gvrlmsgv65">
          <h3 className="font-display text-[22px] font-medium text-violet-deep lg:col-span-4" data-id="element-354" data-mp="3u2220o4tib7d">
            {s.styles.title}
          </h3>
          <ul className="flex flex-wrap items-center gap-x-5 gap-y-3 lg:col-span-8" data-id="element-355" data-mp="3g17u06lomc98">
            {s.styles.items.map(style => <li key={style} className="flex items-center gap-5 text-[18px] text-ink" data-id="element-356" data-mp="3kzj5elrmkutk">
                {style}
                <span aria-hidden="true" className="h-1.5 w-1.5 rotate-45 bg-violet" data-id="element-357" data-mp="24pgsi7ihagvh" />
              </li>)}
            <li className="text-[18px] italic text-muted" data-id="element-358" data-mp="1pjujjf7ffahm">{s.styles.more}</li>
          </ul>
        </div>
      </div>
    </section>;
}